module.exports = __webpack_public_path__ + "img/cameramanager-logo.ec1f76c0.png";